<div class="page-banner-area">
    <div class="container">
        <div class="page-banner-content">
            <h2>Membership</h2>
        </div>
    </div>
</div>

<div class="events-schedules-area ptb-100">
    <div class="container-fluid main_container">
        <div class="section-title">
            <span class="d-block">Join Our Growing Community </span>
            <div class="container">
                <span class="d-block class mt-3 fs-small mb-4">
                    Membership is complimentary and open to IT leaders who wish to stay informed about upcoming
                    RoundtableCxO events. By completing the registration form below, you will receive exclusive event
                    updates and have the opportunity to help shape the agenda by suggesting topics for future CxO
                    dinners and roundtable discussions. We invite you to join a growing community committed to
                    thoughtful dialogue and professional exchange.
                </span>
            </div>

            <!-- <h2>Our Partners</h2> -->
            <!-- <p>At RoundtableCXO, we work closely with a select group of sponsors and partners who share our vision of empowering senior IT leaders through meaningful dialogue and peer exchange. Our curated roundtable events are designed to deliver real value — not only to attendees, but also to the trusted vendors who help make these conversations possible.</p> -->
        </div>
        <div class="  sponsor_container">
            <div class="container ">
                <div class="sponsor-row logo-grid" *ngFor="let chunk of chunkedSponsors; let last = last"
                    [ngClass]="{ 'last-row': last }">
                    <div class="card logo-item" *ngFor="let image of chunk">
                        <img class="sponsor-logo" [src]="'assets/images/partner/' + image" [alt]="image" />
                    </div>
                </div>
            </div>
            <!-- <div class="sponsor-wrapper">
          <div class="sponsor-list" *ngFor="let chunk of chunkedSponsors">
            <div class="sponsor-item"  *ngFor="let image of chunk">
              <img class="sponsor-logo"  [src]="'assets/images/partner/' + image" [alt]="image" />
            </div>
          </div>
        </div> -->

            <div class="row justify-content-center d-none">
                <div class="partner-area ptb-80">
                    <div class="container">
                        <div class="customers-partner-list">

                            <ng-container *ngFor="let chunk of chunkedSponsors">
                                <div class="d-flex justify-content-center flex-wrap mb-4">
                                    <div class="partner-item" *ngFor="let image of chunk">
                                        <a>
                                            <img [src]="'./assets/images/partner/' + image" [alt]="image" />
                                        </a>
                                    </div>
                                </div>
                            </ng-container>

                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center d-none">

                <div class="partner-area ptb-80">
                    <div class="container">
                        <div class="customers-partner-list">

                            <div class="partner-item">
                                <a>
                                    <img src="assets/images/partner/microsoft.png" alt="image">
                                </a>
                            </div>

                            <div class="partner-item">
                                <a>
                                    <img src="assets/images/partner/accimg.png" alt="image">
                                </a>
                            </div>
                            <div class="partner-item">
                                <a>
                                    <img src="assets/images/partner/char.png" alt="image">
                                </a>
                            </div>

                            <div class="partner-item">
                                <a>
                                    <img src="assets/images/partner/ge.png" alt="image">
                                </a>
                            </div>

                            <div class="partner-item">
                                <a>
                                    <img src="assets/images/partner/columbus.png" alt="image">
                                </a>
                            </div>

                            <div class="partner-item">
                                <a>
                                    <img src="assets/images/partner/avid.png" alt="image">
                                </a>
                            </div>

                            <div class="partner-item">
                                <a>
                                    <img src="assets/images/partner/health.png" alt="image">
                                </a>
                            </div>

                            <div class="partner-item">
                                <a>
                                    <img src="assets/images/partner/henny.png" alt="image">
                                </a>
                            </div>

                            <div class="partner-item">
                                <a>
                                    <img src="assets/images/partner/kroger.png" alt="image">
                                </a>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>


<div class="contact-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Stay Informed on Upcoming Events</h2>
        </div>

        <div class="row justify-content-center form_margin">
            <div class="col-lg-12 col-md-12">
                <div class="contact-form">
                    <form id="contactForm" [formGroup]="userForm">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="name" id="name" class="form-control" formControlName="name"
                                        placeholder=" " autocomplete="off">
                                    <label for="fname" class="form-label">Name<sup>*</sup> </label>

                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['name'].valid && (userForm.controls['name'].touched || submitAttempt)">
                                        Name is required
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="email" name="email" id="email" class="form-control" autocomplete="off"
                                        placeholder="" formControlName="email">
                                    <label for="fname" class="form-label">Your Email <sup>*</sup> </label>


                                    <div *ngIf="(userForm.controls['email'].touched || submitAttempt)&& userForm.controls['email'].invalid"
                                        class="text-danger">
                                        <div class="textShadow"
                                            *ngIf="userForm.controls['email'].errors && userForm.controls['email'].errors['required']">
                                            Email is required
                                        </div>
                                        <div class="textShadow"
                                            *ngIf="userForm.controls['email'].errors && userForm.controls['email'].errors['pattern']">
                                            Please enter valid email address
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="company" id="company" class="form-control"
                                        autocomplete="off" placeholder=" " formControlName="company">
                                    <label for="fname" class="form-label">Company <sup>*</sup> </label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['company'].valid && (userForm.controls['company'].touched || submitAttempt)">
                                        Company is required
                                    </div>
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                        autocomplete="off" placeholder=" " formControlName="title">
                                    <label for="fname" class="form-label">Title <sup>*</sup> </label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['title'].valid && (userForm.controls['title'].touched || submitAttempt)">
                                        Title is required
                                    </div>
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                        autocomplete="off" placeholder=" " formControlName="city">
                                    <label for="fname" class="form-label">Your City <sup>*</sup></label>
                                    <div class="text-danger textShadow"
                                        *ngIf="!userForm.controls['city'].valid && (userForm.controls['city'].touched || submitAttempt)">
                                        City is required
                                    </div>
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>


                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label float-label-state"
                                    [class.option-selected]="userForm.controls['state'].value">
                                    <select class="form-control blkcolor form-select state-form-select" id="states"
                                        formControlName="state">
                                        <option value="" disabled>State <sup>*</sup></option>
                                        <option *ngFor="let state of states" [value]="state.name">
                                            {{ state.name }}
                                        </option>
                                    </select>
                                    <small class="text-danger"
                                        *ngIf="userForm.controls['state'].invalid && (userForm.controls['state'].touched || submitAttempt)">
                                        State is required
                                    </small>
                                </div>
                            </div>



                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" minlength="5" maxlength="5"
                                        class="form-control" autocomplete="off" placeholder=" " formControlName="zip">
                                    <label for="fname" class="form-label">Zip </label>
                                    <small class="text-danger error-block"
                                        *ngIf="(userForm.controls['zip'].touched || submitAttempt) && userForm.controls['zip'].errors?.['minlength']">Please
                                        enter valid zipcode</small>


                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="default-btn" (click)="saveForm()"> Submit
                                    <span></span></button>
                                <div id="msgSubmit" class="h3 text-center hidden"></div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="loader" *ngIf="loader">
    <div id="loading"></div>
</div>